<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col">
          <div id="header-container">
            <img class="header-logo" src="@/assets/logo.svg" alt="North Coast Resource Hub">
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" v-for="alert in alerts" v-bind:key="alert.idAlert">
        <div class="col">
          <div class="alert text-center" v-bind:class="'alert-' + alert.alertType" role="alert">
            <span v-html="alert.alertText"></span>
            <br />
            <br />
            To report a problem or change to any of the listings, please click the link below or at the bottom of resource detail pages
            <ReportProblem v-bind:resource="{name:''}"></ReportProblem>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            Welcome to the North Coast Resource Hub. You can find the full list of resources below. You can filter by
            selecting options from the "Filter Resources" menu. If you see an issue with any information contained below
            please report it by clicking "Report a Problem/Change" at the bottom of the Details page for that Resource.
          </p>
        </div>
      </div>
    </div>
    <ResourceSearch></ResourceSearch>
  </div>
</template>

<script>
// @ is an alias to /src
import ResourceSearch from '@/components/ResourceSearch.vue'
import axios from "axios";
import ReportProblem from "@/components/ReportProblem";

export default {
  name: 'home',
  components: {
    ReportProblem,
    ResourceSearch
  },
  data (){
    return {
      alerts: []
    }
  },
  mounted (){
    axios.get("/api/alert.php")
            .then(response => {
              if (response.data){
                this.alerts = response.data;
              }
            });
  }
}
</script>

<style scoped>

</style>